var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#ADB5BD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20C20.9946 20 21.9484 19.6049 22.6517 18.9017C23.3549 18.1984 23.75 17.2446 23.75 16.25C23.75 15.2554 23.3549 14.3016 22.6517 13.5983C21.9484 12.8951 20.9946 12.5 20 12.5C19.0054 12.5 18.0516 12.8951 17.3483 13.5983C16.6451 14.3016 16.25 15.2554 16.25 16.25C16.25 17.2446 16.6451 18.1984 17.3483 18.9017C18.0516 19.6049 19.0054 20 20 20ZM22.5 16.25C22.5 16.913 22.2366 17.5489 21.7678 18.0178C21.2989 18.4866 20.663 18.75 20 18.75C19.337 18.75 18.7011 18.4866 18.2322 18.0178C17.7634 17.5489 17.5 16.913 17.5 16.25C17.5 15.587 17.7634 14.9511 18.2322 14.4822C18.7011 14.0134 19.337 13.75 20 13.75C20.663 13.75 21.2989 14.0134 21.7678 14.4822C22.2366 14.9511 22.5 15.587 22.5 16.25ZM27.5 26.25C27.5 27.5 26.25 27.5 26.25 27.5H13.75C13.75 27.5 12.5 27.5 12.5 26.25C12.5 25 13.75 21.25 20 21.25C26.25 21.25 27.5 25 27.5 26.25ZM26.25 26.245C26.2487 25.9375 26.0575 25.0125 25.21 24.165C24.395 23.35 22.8612 22.5 20 22.5C17.1375 22.5 15.605 23.35 14.79 24.165C13.9425 25.0125 13.7525 25.9375 13.75 26.245H26.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a0c87d530a9241eb5d4355b06deb935b.svg";
export { ForwardRef as ReactComponent };